import type { UploadFolder } from "@repo/fika-shared/src/upload-folder.js"
import { http } from "./http"

export async function uploadFile(file: File, folder: UploadFolder) {
  const folderString = folder.join("/")
  const formData = new FormData()
  formData.append("file", file)

  const response = await http(`/api/upload-file?folder=${folderString}`, {
    method: "POST",
    body: formData,
  })
  if (!response.ok) {
    throw new Error(`file upload failed: ${response.statusText}`)
  }

  const json = (await response.json()) as {
    success?: boolean
    data?: string
    error?: string
  }

  if (json.success && json.data) return json.data
  if (json.error) throw new Error(`file upload failed: ${json.error}`)
  throw new Error("file upload failed")
}
